import type { FC } from 'react'
import { useMemo } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ScoreChart from './ScoreChart'

import data from './data'

const copy = {
  overline: `Your score`,
}

interface OverallResultProps {
  rating: string
}

const OverallResult: FC<OverallResultProps> = ({ rating }) => {
  const score = useMemo(() => data.filter((item) => item.slug === rating)[0], [rating])
  const index = useMemo(() => data.findIndex((item) => item.slug === rating), [rating])

  return (
    <StyledSection variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Overline>{copy.overline}</CopyText.Overline>
          <CopyText.Heading variant="h2" tag="h1">
            {score.heading}
          </CopyText.Heading>
          <CopySummary>{score.summary}</CopySummary>
          <CopyText.Description>{score.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>

      <Section.Contents alignSelf="center">
        <ScoreChart score={index} />
      </Section.Contents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const CopySummary = styled(CopyText.Description)`
  font-weight: 600;
`

export default OverallResult
